<template>
  <div class="flex flex-col-reverse sm:flex-row gap-5 w-full items-center sm:items-start justify-center bg-gray-100 sm:bg-white">
    <div class="flex flex-col flex-1 py-0 px-5 gap-5 sm:gap-2 sm:mx-auto w-full sm:w-fit">
      <SellStepper :step="this.step" />
      <slot></slot>
    </div>
    <div class="bg-white flex-1 flex flex-col gap-3 px-2 py-1 sm:py-5 rounded-lg border-2 border-gray-100 w-full"
        v-bind:class="{'bg-gray-100': colorSolid, 'sm:hidden': mobileOnly}">

      <Accordion id="offer-accordion" :keepOpened="keepAccordionOpen" :defaultOpen="isAccordionOpen" @stateIsOpen="accordionState">
        <mdn-text class="px-3" :class="[titleTextStyle]" slot="AccordionFancyTitle">{{ titleMessage }}</mdn-text>
        <div class="flex flex-col gap-2 sm:gap-5 border-t-2 border-b-2 border-gray-200 py-2 sm:py-5 w-full">
          <mdn-heading id="cardDetailDataFull" size="sm" :level="3">Claro Controle {{offer?.data?.full}}GB</mdn-heading>
          <mdn-heading size="sm" :level="4" class="text-sm text-gray-700 -mt-2">{{offerDetail}}</mdn-heading>
          <div :class="(offer?.descontoExclusivo?.iconeFlag || offer?.descontoExclusivo?.descricaoFlag) && offer?.descontoExclusivo?.esconderFlag === false ? ['bg-gray-100 p-5 pt-3 pb-3'] : ''">
              <div v-if="offer?.descontoExclusivo?.esconderFlag === false" class="flex flex-row gap-3 w-auto pb-3">
                <BrandIconMdn
                  class="w-10"
                  :brandName="offer?.descontoExclusivo?.iconeFlag"
                />
                <mdn-text class="text-black-800 font-bold text-medium">{{offer?.descontoExclusivo?.descricaoFlag}}</mdn-text>
              </div>

              <div class="flex flex-col gap-2 w-auto">
              <mdn-text class="text-grey-600">Apps para navegar ilimitado</mdn-text>
              <div class="flex flex-row gap-2 pb-2 flex-wrap">
                <BrandIconMdn
                  v-for="(app, index) in offer?.apps?.unlimited"
                  :brandName="app.icon"
                  :key="'app-icon-' + index"
                  class="w-8"
                />
              </div>
            </div>
            <div class="flex flex-col gap-2 w-auto" v-if="offer?.apps?.limited.length">
              <mdn-text class="text-grey-600">{{ offer?.data.apps }}GB para navegar nos apps</mdn-text>
              <div class="flex flex-row gap-2 pb-2 flex-wrap">
                <BrandIconMdn
                  v-for="(app, index) in offer?.apps?.limited"
                  :brandName="app.icon"
                  :key="'app-icon-' + index"
                  class="w-8"
                />
              </div>
            </div>
            <div class="flex flex-col gap-2 w-auto">
              <mdn-text class="text-grey-600">Benefícios inclusos</mdn-text>
              <div class="flex flex-row gap-2 flex-wrap">
                <BrandIconMdn
                  v-for="(app, index) in offer?.benefit?.includedApps"
                  :brandName="app.icon"
                  :key="'app-icon-' + index"
                  class="w-8"
                />
              </div>
            </div>
          </div>
          <mdn-text isBody>{{offer.longDescription}} <span>{{offer.subDescription}}</span></mdn-text>
        </div>
        <div class="flex flex-row justify-between items-center pt-4 w-full">
          <mdn-text class="font-medium">Valor do plano:</mdn-text>
          <div class="flex flex-col items-end">
            <mdn-text v-if="offer?.adesaoPromoPrice && offer?.descontoExclusivo?.esconderFlag === false" id="cardDetailPriceRecurrence" class="font-medium text-sm text-red-500 line-through">R$ {{offer?.adesaoPromoPrice?.full}}</mdn-text>
            <mdn-text id="cardDetailPriceRecurrence" class="font-medium text-2xl">R$ {{offer?.price?.adesao.full}}/mês</mdn-text>
            <mdn-text v-if="offer?.descontoExclusivo?.descricaoAdesaoPromocional && offer?.descontoExclusivo?.esconderFlag === false" id="cardDetailPriceRecurrence" class="font-medium text-sm text-gray-700">{{offer?.descontoExclusivo?.descricaoAdesaoPromocional}}</mdn-text>
          </div>
        </div>
      </Accordion>

    </div>
  </div>
</template>

<script>
import { MdnText, MdnHeading } from 'mondrian-vue'
import OfferCommon from '../pages/1-step/Offer/OfferCommon'
import Accordion from '../components/Accordion.vue'
import BrandIconMdn from '../components/BrandIconMdn.vue'
import SellStepper from '../components/SellStepper.vue'

export default {
  name: 'OfferDetailContext',
  components: { MdnText, MdnHeading, Accordion, BrandIconMdn, SellStepper },
  extends: OfferCommon,
  props: {
    offer: Object,
    isSuccess: Boolean,
    isAccordionOpen: { default: true, type: Boolean },
    keepAccordionOpen: { default: false, type: Boolean },
    colorSolid: { default: false, type: Boolean },
    mobileOnly: { default: false, type: Boolean },
    step: String
  },
  data: () => ({ stateIsOpen: undefined }),
  methods: {
    accordionState (event) {
      this.stateIsOpen = event
    }
  },
  computed: {
    titleMessage () {
      if ((this.stateIsOpen) && this.isSuccess) {
        return 'Agora o seu plano mudou!'
      } else if (!this.stateIsOpen) {
        return `Claro Controle ${this.offer.data?.full}GB - R$ ${this.offer.price?.adesao.full}`
      }
      return 'Você está mudando para:'
    },
    offerDetail () {
      const main = `${this.offer.data?.main}GB uso livre`
      const apps = this.offer.apps?.limited.length
        ? this.offer.apps?.limited.length === 1
          ? `+ ${this.offer.data?.apps}GB ${this.offer.apps.limited[0].name}` : `+ ${this.offer.data?.apps}GB redes sociais` : ''
      const bonus = this.offer.data?.bonus ? `+ ${this.offer.data?.bonus}GB de bônus por 12 meses` : ''
      return [main, apps, bonus].join(' ')
    },
    titleTextStyle () {
      return this.isSuccess ? 'text-lg font-medium text-gray-600' : 'text-md'
    }
  },
  mounted () {
    this.stateIsOpen = this.isAccordionOpen
  }
}
</script>
